import shopifyGraphQL from "../services/shopify-graphql"
import { imgUrl } from "../utils/img-url"
import JSON5 from "json5"

class productButton extends HTMLElement {
  constructor() {
    super()

    const productButtonElement = this

    const init = () => {
      handleColorSwitch()
    }

    const handleColorSwitch = () => {
      const colorSwitch = productButtonElement.querySelector(".js-color-switch")

      if (!colorSwitch) return false

      const handle = colorSwitch.dataset.handle
      const buttons = colorSwitch.querySelectorAll(".color-switch__item")
      const useAltImage = colorSwitch.dataset.alt === "true"
      let size = "petite"

      if (useAltImage) {
        size = "one_size"
      }

      if (handle && buttons.length > 0) {
        buttons.forEach((button) => {
          button.addEventListener("click", async (e) => {
            e.preventDefault()

            const color = button.dataset.color
            const images = await getProductColorImages(handle, color)

            // Handle the events
            handleProductColorImages(images, color, size)
            handleActiveStateColorSwitcher(buttons, color)
          })
        })
      }
    }

    const getProductColorImages = async (handle, color) => {
      const colorName = color.replace(" ", "")
      const colorKey = color.replace(" ", "_").toLowerCase()

      // Create selectedOptions argument
      const options = productButtonElement.querySelector(".js-option")
      const selectedOptionsJSON = JSON.parse(options.value)
      const selectedColorOption = [{ name: "Color", value: color }]
      const selectOptionsEdited = selectedOptionsJSON.map((obj) => selectedColorOption.find((o) => o.name === obj.name) || obj)
      const selectedOptions = JSON5.stringify(selectOptionsEdited, { quote: '"' })

      return await shopifyGraphQL.get(
        `
        query getProductByHandle{
          product(handle: "${handle}") {
            variantBySelectedOptions(selectedOptions: ${selectedOptions}) {
              image{
                url
              }
              customMetafields: metafields(identifiers: [ 
                {namespace: "surfturf", key: "variant_image"}, 
                {namespace: "surfturf", key: "image_property_1"}, 
                ]) { 
                namespace 
                key
                value
              }
            }
            ${colorName}Image: metafield(namespace: "custom", key: "${colorKey}_default_image") {
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                  }
                }
              }
            }
            ${colorName}ImageHover: metafield(namespace: "custom", key: "${colorKey}_hover_image") {
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                  }
                }
              }
            }
          }
        }`
      )
    }

    const handleActiveStateColorSwitcher = (buttons, color) => {
      buttons.forEach((button) => {
        if (button.dataset.color === color) {
          button.classList.add("color-switch__item--active")
        } else {
          button.classList.remove("color-switch__item--active")
        }
      })
    }

    const handleProductColorImages = (images, color, size) => {
      const colorName = color.replace(" ", "")
      const defaultContainer = productButtonElement.querySelector("img:nth-child(1)")
      const hoverContainer = productButtonElement.querySelector("img:nth-child(2)")

      if (defaultContainer) {
        if (images.data.product) {
          if (images.data.product[`${colorName}Image`]) {
            defaultContainer.src = imgUrl(images.data.product[`${colorName}Image`].reference.image.originalSrc, "800x")
            defaultContainer.srcset = imgUrl(images.data.product[`${colorName}Image`].reference.image.originalSrc, "800x")
          } else if (images.data.product.variantBySelectedOptions.customMetafields[0] !== null) {
            //const imageProperties = images.data.product.variantBySelectedOptions.customMetafields.find((element) => 'image_property_1' in element)
            const imageProperties = images.data.product.variantBySelectedOptions.customMetafields.find((element) => {
              if (element) {
                if (element.key === "image_property_1") {
                  return element
                } else {
                  return null
                }
              } else {
                return null
              }
            })
            if (imageProperties) {
              const indexOfPetite = JSON.parse(imageProperties.value).indexOf(size)
              if (indexOfPetite !== -1) {
                defaultContainer.src = JSON.parse(images.data.product.variantBySelectedOptions.customMetafields[0].value)[indexOfPetite][0].src
                defaultContainer.srcset = JSON.parse(images.data.product.variantBySelectedOptions.customMetafields[0].value)[indexOfPetite][0].src
              } else {
                defaultContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
                defaultContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
              }
            } else {
              defaultContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
              defaultContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
            }
          } else {
            defaultContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
            defaultContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
          }
        }
      }

      if (hoverContainer) {
        if (images.data.product) {
          if (images.data.product[`${colorName}ImageHover`]) {
            hoverContainer.src = imgUrl(images.data.product[`${colorName}ImageHover`].reference.image.originalSrc, "800x")
            hoverContainer.srcset = imgUrl(images.data.product[`${colorName}ImageHover`].reference.image.originalSrc, "800x")
          } else if (images.data.product.variantBySelectedOptions.customMetafields[0] !== null) {
            const imageProperties = images.data.product.variantBySelectedOptions.customMetafields.find((element) => {
              if (element) {
                if (element.key === "image_property_1") {
                  return element
                } else {
                  return null
                }
              } else {
                return null
              }
            })
            if (imageProperties) {
              const indexOfPetite = JSON.parse(imageProperties.value).indexOf(size)
              if (indexOfPetite !== -1) {
                const lastIndex = JSON.parse(images.data.product.variantBySelectedOptions.customMetafields[0].value)[indexOfPetite].length - 1
                hoverContainer.src = JSON.parse(images.data.product.variantBySelectedOptions.customMetafields[0].value)[indexOfPetite][lastIndex].src
                hoverContainer.srcset = JSON.parse(images.data.product.variantBySelectedOptions.customMetafields[0].value)[indexOfPetite][lastIndex].src
              } else {
                hoverContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
                hoverContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
              }
            } else {
              hoverContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
              hoverContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
            }
          } else {
            hoverContainer.src = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
            hoverContainer.srcset = imgUrl(images.data.product.variantBySelectedOptions.image.url, "800x")
          }
        }
      }
    }

    init()
  }
}

customElements.define("product-button", productButton)
